import { AppUser } from '../models/utilities/app-user';
import { ServiceCenter } from "../models/utilities/service-center";
import { BaseModuleState } from './_BaseModuleState';

/**
 * The userdata module shape
 */
export class UserdataModuleState extends BaseModuleState {

    public user : AppUser = new AppUser();
    public activeServiceCenter: ServiceCenter = new ServiceCenter();

}
